const debounceTrailing = {
  leading: false,
  trailing: true,
  maxWait: 800,
};

const country_code = [
  {
    name: "Malaysia",
    dial_code: "+60",
    code: "MY",
    mobileMinLength: 8,
    mobileMaxLength: 10,
    localMinLength: 8,
    localMaxLength: 20,
  },
  {
    name: "Singapore",
    dial_code: "+65",
    code: "SG",
    mobileMinLength: 8,
    mobileMaxLength: 10,
    localMinLength: 8,
    localMaxLength: 20,
  },
];

const country = [{ value: "Malaysia", label: "Malaysia" }];

const weekdays = {
  1: { name: "Monday", abbr: "Mon" },
  2: { name: "Tuesday", abbr: "Tue" },
  3: { name: "Wednesday", abbr: "Wed" },
  4: { name: "Thursday", abbr: "Thu" },
  5: { name: "Friday", abbr: "Fri" },
  6: { name: "Saturday", abbr: "Sat" },
  7: { name: "Sunday", abbr: "Sun" },
};

const order_type = [
  {
    id: "order-delivery",
    text: "Delivery",
    value: "delivery",
    restaurantSetting: "delivery",
  },
  // {
  //   id: "order-dine-in",
  //   text: "Dine In",
  //   value: "dine-in",
  //   settingValue: "dine_in"
  // },
  {
    id: "order-pick-up",
    text: "Pick Up",
    value: "pick-up",
    restaurantSetting: "pick_up",
  },
];

const amenityIcon = {
  "24 Hours": "fullhour",
  "Air-Conditioner": "aircond",
  "Alcohol Served": "alcohol",
  "Free WIFI": "wifi",
  "Live Music": "music",
  "Smoking (Indoor)": "smokein",
  "Smoking (Outdoor)": "smokeout",
  "VIP Room": "vip",
  "Free Parking": "parking",
  "Baby Chair": "babychair",
  "Accept Credit Cards": "creditcard",
  "Wheel Chair": "wheelchair",
  "Play Area": "playarea",
};

const MallCancellationReason = [
  {
    value: 1,
    label: "Seller is not responsive to my inquiries",
  },
  {
    value: 2,
    label: "Modify existing order (colour, size, address, voucher, etc)",
  },
  {
    value: 3,
    label: "Changed mind",
  },
  {
    value: 4,
    label: "Found cheaper price",
  },
  {
    value: 0,
    label: "Others",
  },
];

const MallRefundReason = [
  {
    value: 1,
    label: "Did not receive the order,",
  },
  {
    value: 2,
    label: "Received incomplete product(s) (missing quantity or accessories)",
  },
  {
    value: 3,
    label:
      "Received wrong product(s) (wrong size, wrong colour, different product etc.)",
  },
  {
    value: 4,
    label:
      "Received product(s) with physical damage (dented, scratched, shattered etc.",
  },
  {
    value: 0,
    label: "Others",
  },
];

export {
  debounceTrailing,
  country_code,
  country,
  weekdays,
  order_type,
  amenityIcon,
  MallCancellationReason,
  MallRefundReason,
};
